import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import UIBox from 'UIComponents/layout/UIBox';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { OLAF } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import TrackedZeroState from './zero-states/TrackedZeroState';
import RequestAccessToInboxContainer from '../../access-control/components/RequestAccessToInboxContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingPermissionFlexContainer = styled(UIFlex).withConfig({
  displayName: "MissingPermission__MissingPermissionFlexContainer",
  componentId: "sc-1q83tpa-0"
})(["margin-top:100px;width:370px !important;margin-left:auto;margin-right:auto;"]);
const MissingPermissionWrapper = styled.div.withConfig({
  displayName: "MissingPermission__MissingPermissionWrapper",
  componentId: "sc-1q83tpa-1"
})(["background-color:", ";height:100%;"], OLAF);
class MissingPermission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPromptOpen: false
    };
    this.closeRequestAccessPrompt = this.closeRequestAccessPrompt.bind(this);
    this.openRequestAccessPrompt = this.openRequestAccessPrompt.bind(this);
  }
  openRequestAccessPrompt() {
    this.setState({
      isPromptOpen: true
    });
  }
  closeRequestAccessPrompt() {
    this.setState({
      isPromptOpen: false
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(MissingPermissionWrapper, {
      className: "selenium-test-marker-missing-permissions-zero-state",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "MISSING_PERMISSION_SUCCESS"
      }), /*#__PURE__*/_jsxs(MissingPermissionFlexContainer, {
        justify: 'start',
        align: 'center',
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "keys",
            width: "100px"
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          className: "m-top-6 selenium-test-marker-missing-permissions-zero-state",
          children: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.missing-permissions.title"
            })
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx("p", {
            style: {
              textAlign: 'center'
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.missing-permissions.firstBody"
            })
          })
        }, 1), /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: this.openRequestAccessPrompt,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.missing-permissions.button"
          })
        })]
      }), this.state.isPromptOpen ? /*#__PURE__*/_jsx(RequestAccessToInboxContainer, {
        onReject: this.closeRequestAccessPrompt,
        onConfirm: this.closeRequestAccessPrompt
      }) : null]
    });
  }
}
MissingPermission.displayName = 'MissingPermission';
export default TrackedZeroState({
  zeroStateName: 'MissingPermission'
})(MissingPermission);